import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { rootUrl } from '../../helpers'
import { FaBoxOpen, FaPlus, FaTrash } from 'react-icons/fa'
import { useAuth } from '../../context/auth-context'
import Select from "react-select";
import ConfirmationDialog from '../../components/ConfirmationDialog'

export default function Opening() {


    const [coa, setCoa] = useState([])
    const [open, setOpen] = useState([])
    const [bank, setBank] = useState([])
const [mod, setMod] = useState({ open: false, title: '', message: '', onConfirm: null })

const handleModClose = () =>{
  setMod({ ...mod, open: false });
}
    const auth = useAuth()

        const fetchData = async () =>{
                try{

                    const data = await axios.get(rootUrl(`/getOpen/${auth.user.id}`))
                    
                    setCoa(data.data.coa)
                    setOpen(data.data.open)
                    setBank(data.data.bank)

                }catch(e){
                    toast.error(e?.message)
                }
        }

        useEffect(()=>{
            fetchData()
        },[])

        const [modalOpen, setModalOpen] = useState(false);

        const handleSubmit = async (data) => {

            data['cid'] = auth.user.cid
            data['year'] = 2025;
            data['uid'] = auth.user.id.toString();


          const resp = await axios.post(rootUrl(`/postOpen`), data)

          if(resp.data.status == 200){
            toast.success("Successful")
          }else{
            toast.error("Something went wrong")
          }
          
        };
        
        const delOpening  = async (bid)=>{

        setMod({
          open: true,
          title: 'Warning',
          message: 'Are you sure you want to delete this items?',
          onConfirm: async () => {
            try{
              const resp = await axios.get(rootUrl(`/delOpening/${bid}`))
              handleModClose()
              fetchData()
              
          }catch(e){
              toast.error(e?.message)
          }
          }
        })
       
          
          

        }

  return (

    <div className='p-4 bg-white rounded-lg shadow-lg'>
<ConfirmationDialog
                open={mod.open}
                title={mod.title}
                message={mod.message}
                onConfirm={mod.onConfirm}
                onCancel={handleModClose}
            />

<div className='flex justify-between'>
<h2 className='flex items-center font-semibold text-2xl'> <FaBoxOpen/> Opening Balances  </h2>

<button onClick={() => setModalOpen(true)} className="px-4 py-2 bg-blue-950 text-white rounded m-1">
Opening balance
</button>
</div>
        
        <hr />

        {
            open?
            <>
                <AddItemModal isOpen={modalOpen} onClose={() => setModalOpen(false)} onSubmit={handleSubmit} coa={coa} bank={bank} />

                        <table className="w-full border-collapse border border-gray-300 mt-5">
                <thead>
                <tr className="bg-blue-950 text-white">
                    <th className="border p-2 text-left">Sno</th>
                    <th className="border p-2 text-left">Account</th>
                    <th className="border p-2 text-right">Amount</th>
                    <th className="border p-2 text-left">Action</th>
                </tr>
                </thead>
                <tbody>
                {open.map((item, index) => (
                    <tr key={index} className="text-center">
                    <td className="border p-2 text-left">{++index}</td>
                    <td className="border p-2 text-left">{item.type == 'COA'?coa.find(a=>a.account === item.fkey)?.account:bank.find(a=>a.id === item.fkey)?.name}</td>
                    <td className="border p-2 text-right">{item.amount}</td>
                    <td className="border p-2 text-left"> <FaTrash className='text-red-500' onClick={()=>delOpening(item.fkey)} /> </td>
                    </tr>
                ))}
                </tbody>
            </table>
            </>
            :
            <></>
        }


    </div>
  )
}


const AddItemModal = ({ isOpen, onClose, onSubmit, coa, bank  }) => {
  const [formData, setFormData] = useState({
    amount: "",
    type: "",
    fkey: "",
  });

  const typeOptions = ["Cashbook", "COA"]; 

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const isEmpty = Object.values(formData).some(value => !value);
    if(isEmpty){
        toast.error("Ensure all fields are filled")
        return
    }
    onSubmit(formData); 
    onClose(); 
  };

  const fkeyOptions = coa
  .filter((a) => !["1", "2", "3"].includes(a.account[0]))
  .map((fkey) => ({
    value: fkey.account,
    label: fkey.account,
  }));

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-96">
        <h2 className="text-xl font-semibold mb-4">Add Item</h2>
        <form onSubmit={handleSubmit}>
          {/* Amount Input */}
          <div className="mb-3">
            <label className="block text-sm font-medium">Amount</label>
            <input
              type="text"
              name="amount"
              value={formData.amount}
              onChange={handleChange}
              className="w-full border p-2 rounded"
              placeholder="Enter amount"
              required
            />
          </div>

          {/* Type Dropdown */}
          <div className="mb-3">
            <label className="block text-sm font-medium">Type</label>
            <select
              name="type"
              value={formData.type}
              onChange={handleChange}
              className="w-full border p-2 rounded"
              required
            >
              <option value="">Select Type</option>
              {typeOptions.map((type, index) => (
                <option key={index} value={type}>
                  {type}
                </option>
              ))}
            </select>
          </div>



{
    formData.type === "COA"?
    <>
        {/* FKey Dropdown */}
        <div className="mb-3">
            <label className="block text-sm font-medium">Coa</label>
            {/* <Select
              options={fkeyOptions}
              value={fkeyOptions.find((opt) => opt.value === formData.fkey)}
              onChange={(selected) => handleChange("fkey", selected.value)}
              className="w-full"
              placeholder="Select Coa"
              isSearchable
              name='fkey'
            /> */}
            <select
              name="fkey"
              value={formData.fkey}
              onChange={handleChange}
              className="w-full border p-2 rounded"
              required
            >
              <option value="">Select COA</option>
              
              {
                coa
                .filter((a) => !["1", "2"].includes(a.account[0]))
                .map((fkey, index) => (
                  <option key={index} value={fkey.account}>
                    {fkey.account} {fkey.name}
                  </option>
              ))}
            </select>
          </div>
    </>
    :
    <>
      {/* FKey Dropdown */}
      <div className="mb-3">
            <label className="block text-sm font-medium">Bank</label>
            <select
              name="fkey"
              value={formData.fkey}
              onChange={handleChange}
              className="w-full border p-2 rounded"
              required
            >
              <option value="">Select Cashbook</option>
              {bank.map((fkey, index) => (
                <option key={index} value={fkey.id}>
                  {fkey.name}
                </option>
              ))}
            </select>
          </div>
    </>
}
          

          


          {/* Buttons */}
          <div className="flex justify-end space-x-2">
            <button
              type="button"
              className="px-4 py-2 bg-gray-300 rounded"
              onClick={onClose}
            >
              Cancel
            </button>
            <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded">
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};


